'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const Events = require('constants/Events');
const Constants = require('constants/Constants');

require('owl.carousel/src/scss/_core.scss');
require('owl.carousel/src/scss/_animate.scss');
require('owl.carousel');

//a 3D rendering library
const THREE = require('three');

//a library to load 3ds models into three js
const TDSLoader = require('three-3dsloader');

const PlatformHeroVideoPopup = require('components/Platform/PlatformHeroVideoPopup/PlatformHeroVideoPopup');

require('./IndexPartners.less');

const Selectors = {
    el: '.IndexPartners',
    wrapper: '.IndexPartners-wrapper',
    title: '.IndexPartners-partnersBlockHeadTitle',
    slider: '.IndexPartners-partnersSlider',
    slide: '.IndexPartners-slide',
    blockHead: '.IndexPartners-partnersBlockHead',
    block: '.IndexPartners-partnersBlock',
    blockDescr: '.IndexPartners-partnersBlockDescr',
    canvasWrapper: '.IndexPartners-canvas',
    cardWrapper: '.IndexPartners-cardsWrapper',

    extraBlock: '.IndexPartners-cardsExtraBlock',

    firstPartner: '.IndexPartners-partnersBlock--0',
    secondPartner: '.IndexPartners-partnersBlock--1',

    innovating: '.IndexInnovating',
    innovatingTitle: '.IndexInnovating-title',
    innovatingTitleWrapper: '.IndexInnovating-titleWrapper',
    innovatingBg: '.IndexInnovating-background',
    innovatingPhone: '.IndexInnovating-phoneWrapper',

    playBtn: '.play-video'
};

// const ClassNames = {
// };

const BindFunctions = [
    'onResize',
    'toggleSizeWrapper',
    'init3DScene',
    'initTextureLoader',
    'getTextures',
    'createAnimations',
    'onScroll',
    'initExtraCards'
];

const ChildViews = {
    'PlatformHeroVideoPopup': {
        selector: '.PlatformHeroVideoPopup',
        viewConstructor: PlatformHeroVideoPopup
    }
};

const Assets = {
    folderAttr: 'data-assets-folder',

    card3d: 'card.3DS',

    textureCard: 'Card_Color_New.jpg',
    textureChip: 'Chip_Color_New.jpg',

    cardTextures: 'Card_Textures.jpg',

    cardShadow: 'Card_Shadow.png',
    cardShadowEnd: 'Card_Shadow_End.png'
};

const cameraFarPlane = 1000;
const cameraFOV = 9.452;
const cameraNearPlane = 0.1;
const cameraPositionZ = 83.5;
const baseVideoWidth = 550; // based on video aspect
const baseCanvasHeight = 960;
const controlPoints = [0, /*38, 51,*/ 85, 100]; //do not change first and the last one
const settings = {
    card: {
        position: [0,0,0],
        rotation: [-1.740, -0.065, -3.033],
        scale: [1,0.3,1],
        animation: {
            rotation: [-1.490, -0.065, -2.853],
            position: [0, 0, -50],
            endRotation: [0.100, -0.955, -4.410]
        }
    },
    textures: [{ // card
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, { //chip
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, { //textures of card
        offset: [1 / 1.498, 0],
        scale: [1 / 3, 1],
        rotation: [0]
    }, { //textures for shadow of card
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, { //textures for shadow_end of card
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }]
};

module.exports = Base.extend({

    el: Selectors.el,

    events: {
        'click .play-video': 'onPlayVideoClick'
    },

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);

        app.vent.on(Events.common.pageLoaded, () => {
            setTimeout(() => {
                this.isCarouselActive = false;
                this.canvasVisible = true;

                this.isPhone = window.app.settings.isPhone && window.matchMedia('(max-width: 767px)').matches;

                this.titleObj = {
                    $container: this.$(Selectors.title),
                    className: 'IndexPartners-partnersBlockHeadTitleLine',
                    autoWidth: true
                };
                app.utils.splitMultilineToSeparateSpans(this.titleObj);

                this.options = options;

                // app.vent.on(Events.home.hero.sequenceEnded, this.initTextureLoader);
                this.initTextureLoader();

                this.viewsRegistration(ChildViews);
            }, 2000);
        });
    },

    onPlayVideoClick: function (e) {
        const $item = $(e.currentTarget);
        const videoId = $item.closest(Selectors.playBtn).data('href');

        this.views.PlatformHeroVideoPopup.openPopup(videoId);
    },

    activateSectionShown: function ($el) {
        if (!$el || $el && !$el.is(this.$(Selectors.blockHead))) {
            return;
        }

        this.animateTitleTimeline = app.utils.animateTextByLines(this.titleObj, {
            lineDuration: 1000,
            lineDelay: 30,
            shift: 30
        });

        this.$(Selectors.cardWrapper).removeClass(Constants.cssClasses.isHide);
    },

    initExtraCards: function () {
        if (this.isPhone) {
            return;
        }

        this.animations.push({
            obj: $(Selectors.extraBlock + ':last-child'),
            tp: '$opacity',
            cp: [
                [controlPoints[0], [0]],
                [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange - 3, [0]],
                [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange, [1]],
                [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 7, [1]],
                [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 5, [0]],
                [controlPoints[2], [0]]
            ]
        });

        this.animations.push({
            obj: $(Selectors.extraBlock + ':last-child'),
            tp: '$left',
            cp: [
                [controlPoints[0], [-30]],
                [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange - 3, [-30]],
                [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange, [0]],
                [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 7, [0]],
                [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 5, [30]],
                [controlPoints[2], [30]]
            ]
        });
    },

    initTextureLoader: function () {
        this.$canvasWrapper = this.$(Selectors.canvasWrapper);

        this.folder = this.$el.attr(Assets.folderAttr);

        const texturesSRC = [
            Assets.textureCard,
            Assets.textureChip,
            Assets.cardTextures,
            Assets.cardShadow,
            Assets.cardShadowEnd
        ].map(texture => this.folder + texture);

        Promise.all(this.getTextures(texturesSRC))
            .then((textures) => {
                return new Promise((resolve) => {
                    this.init3DScene(textures, resolve);
                });
            })
            .then(this.onResize)
            .catch(err => console.error(err));
    },

    getTextures: function (texturesSources) {
        const loader = new THREE.TextureLoader();

        return texturesSources.map(textureSource => {
            return new Promise((resolve, reject) => {
                loader.load(
                    textureSource,
                    texture => {
                        resolve(texture);
                    },
                    undefined,
                    err => reject(err)
                );
            });
        });
    },

    init3DScene: function (textures, resolve) {
        if (!this.isPhone) {
            this.textures = textures || [];

            this.textures.forEach(function (item, index) {
                item.offset = new THREE.Vector2(...settings.textures[index].offset);
                item.repeat.set(...settings.textures[index].scale);
                item.rotation = settings.textures[index].rotation[0];
            });

            //selecting a renderer to use
            this.renderer = new THREE.WebGLRenderer({
                antialias: true,
                alpha: true
            });

            // this.renderer.outputEncoding = THREE.sRGBEncoding;
            this.renderer.physicallyBasedShading = true;
            this.renderer.setPixelRatio(window.devicePixelRatio || 1); //set retina for uses devices
            this.$canvasWrapper.append(this.renderer.domElement);

            //initialize scene and camera
            this.scene = new THREE.Scene();
            this.camera = new THREE.PerspectiveCamera(cameraFOV, 1, cameraNearPlane, cameraFarPlane);
            this.camera.position.z = cameraPositionZ;
            this.camera.lookAt(0, 0, 0);
            this.scene.add(this.camera);

            const ambientLight = new THREE.AmbientLight(0xffffff, 1);
            this.scene.add(ambientLight);


            (new TDSLoader()).load(this.folder + Assets.card3d, function (object) {
                // material without shader, material
                const materialCard = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    map: textures[0]
                });

                const materialContacts = new THREE.MeshPhongMaterial({
                    color: 0xffffff,
                    map: textures[1]
                });

                object.children[0].material = materialCard;
                object.children[1].material = materialContacts;
                object.remove(object.children[2]);

                object.position.set(...settings.card.position);
                object.rotation.set(...settings.card.rotation);

                object.scale.set(...settings.card.scale);

                const geometry = object.children[0].geometry; // substitute the path to your geometry
                geometry.computeBoundingBox(); // otherwise geometry.boundingBox will be undefined
                const boundingBox = geometry.boundingBox;

                const planeBorderRadius = 0.25;
                const planeGeometry = app.utils.makeRoundedCornerPlane(
                    geometry.boundingBox.max.y - geometry.boundingBox.min.y - planeBorderRadius * 2 + 0.02,
                    geometry.boundingBox.max.z - geometry.boundingBox.min.z - planeBorderRadius * 2 + 0.01,
                    planeBorderRadius
                );


                const whiteCardMaterial = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    map: textures[2],
                    side: THREE.FrontSide,
                    transparent: true
                });

                const planeWhiteCard = new THREE.Mesh(planeGeometry, whiteCardMaterial);
                planeWhiteCard.position.x = 0.01;
                planeWhiteCard.position.y = boundingBox.max.x + 0.035;

                planeWhiteCard.rotation.x = -Math.PI / 2;
                planeWhiteCard.rotation.z = Math.PI;
                object.add(planeWhiteCard);

                const planeGeometryShadow = app.utils.makeRoundedCornerPlane(
                    geometry.boundingBox.max.y - geometry.boundingBox.min.y - planeBorderRadius * 2 - 0.5,
                    (geometry.boundingBox.max.z - geometry.boundingBox.min.z - planeBorderRadius * 2)
                        - (geometry.boundingBox.max.z - geometry.boundingBox.min.z) * 0.8, // 4/5
                    planeBorderRadius
                );


                const shadowMaterial = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    map: textures[3],
                    side: THREE.FrontSide,
                    transparent: true
                });

                this.shadowMaterial = shadowMaterial;

                const planeShadow = new THREE.Mesh(planeGeometryShadow, shadowMaterial);
                planeShadow.position.y = boundingBox.min.x - 0.01;
                planeShadow.position.z = -(geometry.boundingBox.max.z - geometry.boundingBox.min.z) * 0.5; // 2/5 - ((1/5) / 2)

                planeShadow.rotation.x = -Math.PI / 2;
                planeShadow.rotation.z = Math.PI - 0.04;
                object.add(planeShadow);

                const planeGeometryShadowEnd = app.utils.makeRoundedCornerPlane(
                    geometry.boundingBox.max.y - geometry.boundingBox.min.y - planeBorderRadius * 2 + 2,
                    geometry.boundingBox.max.z - geometry.boundingBox.min.z - planeBorderRadius * 2 + 4,
                    planeBorderRadius
                );


                const shadowEndMaterial = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    map: textures[4],
                    side: THREE.FrontSide,
                    transparent: true
                });

                this.shadowEndMaterial = shadowEndMaterial;

                const planeShadowEnd = new THREE.Mesh(planeGeometryShadowEnd, shadowEndMaterial);
                planeShadowEnd.position.x = -1.85;
                planeShadowEnd.position.y = boundingBox.max.x + 0.045;
                planeShadowEnd.position.z = -0.25;

                planeShadowEnd.rotation.x = Math.PI / 2;
                planeShadowEnd.rotation.z = Math.PI;
                object.add(planeShadowEnd);


                this.card = object;
                this.scene.add(object);

                resolve();
            }.bind(this));

            $(window).on('resize', this.onResize);
            app.vent.on(Events.common.scroll, this.onScroll);

            this.renderer.render(this.scene, this.camera);
        } else {
            $(window).on('resize', this.onResize);
            resolve();
        }
    },

    onResize: function () {
        this.isPhone = window.app.settings.isPhone && window.matchMedia('(max-width: 767px)').matches;

        if (window.matchMedia('(min-width: 768px)').matches) {
            this.toggleCarousel(false);
            this.toggleSizeWrapper(false);
        } else {
            this.toggleCarousel(true);
            this.toggleSizeWrapper(true);
        }

        if (this.isPhone) {
            return;
        }

        const innovatingPhone = $(Selectors.innovatingPhone)[0].getBoundingClientRect();
        this.innovatingBgHeight = $(Selectors.innovatingTitleWrapper).height();

        const canvasBB = this.$canvasWrapper[0].getBoundingClientRect();
        const canvasLeft = canvasBB.left;
        this.width = canvasBB.width;
        this.height = canvasBB.height;

        let realVideoWidth = this.width;

        const heightMultiplier = this.height / baseCanvasHeight;
        const widthMultiplier = baseVideoWidth / realVideoWidth;
        const tanFOV = Math.tan(cameraFOV * Math.PI / 360);
        this.camera.fov = (360 / Math.PI) * Math.atan(tanFOV * heightMultiplier * widthMultiplier);


        this.viewOffset = [0, 0];

        let startScroll = $(Selectors.blockHead).offset().top - window.innerHeight;

        this.paddingTopPartners = Number($(Selectors.el).css('padding-top')
            .slice(0,-2));
        this.halfHeightTitleHead = $(Selectors.title).height() / 2;

        this.cpPositions = {
            head: $(Selectors.blockHead).offset().top
                + ($(Selectors.blockHead).height() / 2)
                - (window.innerHeight / 2)
                - startScroll,
            firstPartner: $(Selectors.firstPartner).offset().top
                - ($(Selectors.firstPartner).height() / 2)
                - (window.innerHeight / 2)
                - startScroll,
            secondPartner: $(Selectors.secondPartner).offset().top
                - ($(Selectors.secondPartner).height() / 2)
                - (window.innerHeight / 2)
                - startScroll,
            secondPartnerEnd: $(Selectors.secondPartner).offset().top
                + $(Selectors.secondPartner).height()
                - (window.innerHeight / 2)
                - startScroll,
            startScroll: startScroll,
            scrollRange: $(Selectors.innovatingBg).offset().top
                - startScroll
                - (window.innerHeight / 2)
                + (this.innovatingBgHeight / 2)
                - 20
        };

        let xShift = (innovatingPhone.left - canvasLeft) / 2 + 15;
        xShift = (xShift > this.width / 4.3)
            ? (this.width / 4.3) - 20
            : xShift;

        this.xShiftPoints = [
            [controlPoints[0], [0]],
            [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 5, [0]],
            [controlPoints[2], [xShift]]
        ];

        this.camera.clearViewOffset();
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.width, this.height);
        this.renderer.render(this.scene, this.camera);

        this.createAnimations();
        this.initExtraCards();
        // this.prevProgress = null;
        this.onScroll(window.pageYOffset);
    },

    createAnimations: function () {
        this.animations = [
            // {
            //     obj: this.renderer.domElement,
            //     tp: 'css-translate',
            //     cp: [
            //         [controlPoints[0], [0, window.innerHeight / 2, 0]],
            //
            //         [this.cpPositions.head * 100 / this.cpPositions.scrollRange, [0, 0, 0]],
            //
            //         [controlPoints[2], [0, 0, 0]]
            //     ]
            // },
            {
                obj: this.card,
                tp: 'position',
                cp: [
                    [controlPoints[0], [...settings.card.position]],

                    [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 5,
                        [...settings.card.position]],

                    [controlPoints[2], [...settings.card.animation.position]]
                ]
            },
            {
                obj: this.card,
                tp: 'rotation',
                cp: [
                    [controlPoints[0], [...settings.card.rotation]],

                    [this.cpPositions.firstPartner * 100 / this.cpPositions.scrollRange - 4,
                        [...settings.card.rotation]],
                    [this.cpPositions.firstPartner * 100 / this.cpPositions.scrollRange - 2,
                        [...settings.card.animation.rotation]],
                    [this.cpPositions.firstPartner * 100 / this.cpPositions.scrollRange,
                        [...settings.card.rotation]],

                    [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange - 4,
                        [...settings.card.rotation]],
                    [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange - 2,
                        [...settings.card.animation.rotation]],
                    [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange,
                        [...settings.card.rotation]],

                    [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 5,
                        [...settings.card.rotation]],

                    [controlPoints[2], [...settings.card.animation.endRotation]]
                ]
            },{
                obj: this.textures[2], //textures of card
                tp: 'tex_offset',
                cp: [
                    [controlPoints[0], [...settings.textures[2].offset]],
                    [this.cpPositions.firstPartner * 100 / this.cpPositions.scrollRange - 2,
                        [...settings.textures[2].offset]],
                    [this.cpPositions.firstPartner * 100 / this.cpPositions.scrollRange, [1 / 2.998, 0]],
                    [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange - 2, [1 / 2.998, 0]],
                    [this.cpPositions.secondPartner * 100 / this.cpPositions.scrollRange, [0, 0]],
                    [controlPoints[2], [0, 0]]
                ]
            },{
                obj: this.shadowMaterial,
                tp: 'mat_opacity',
                cp: [
                    [controlPoints[0], [0.7]],
                    [this.cpPositions.secondPartnerEnd * 100 / this.cpPositions.scrollRange - 5, [0.7]],
                    [controlPoints[2], [0]]
                ]
            },{
                obj: this.shadowEndMaterial,
                tp: 'mat_opacity',
                cp: [
                    [controlPoints[0], [0]],
                    [95, [0]],
                    [controlPoints[2], [1]]
                ]
            }];
    },


    onScroll: function (scrollTop) {
        if (typeof this.cpPositions === 'undefined') {
            return;
        }

        const progressRaw = 100
            * (scrollTop - this.cpPositions.startScroll)
            / (this.cpPositions.scrollRange);

        const progress = Math.max(Math.min(progressRaw, 100), 0);

        if (progressRaw < 0) {
            if (this.canvasVisible) {
                this.$canvasWrapper.css('visibility', 'hidden');
                this.canvasVisible = false;
            }
        } else {
            if (!this.canvasVisible) {
                this.$canvasWrapper.css('visibility', 'visible');
                this.canvasVisible = true;
            }
        }

        if (progressRaw < -10) {
            return;
        }

        this.prevProgress = progress;

        const getInterpolated = (cp, progress) => {
            const len = cp.length;
            let prevPercentage = 0;

            for (let i = 0; i < len; i++) {
                let percentage = cp[i][0];
                let points = cp[i][1];

                if (percentage === progress) {
                    return points;
                }

                if (percentage > progress) {
                    const localProgress = (progress - prevPercentage) / (percentage - prevPercentage);
                    const res = [];

                    for (let j = 0; j < points.length; j++) {
                        res[j] = app.utils.easingFunctions(cp[i - 1][1][j], points[j], localProgress, 'easeInOutSine');
                    }

                    return res;
                }

                prevPercentage = percentage;
            }
        };

        let xShift = getInterpolated(this.xShiftPoints, progress)[0];

        let yShift = scrollTop
                - this.cpPositions.startScroll
                - (window.innerHeight / 2)
                - this.paddingTopPartners
                - this.halfHeightTitleHead;

        let yShiftEnd = scrollTop
                - (this.cpPositions.startScroll + this.cpPositions.scrollRange);

        if (yShift <= 0) {
            this.yShift = Math.round(yShift);
        } else if (yShiftEnd >= 0) {
            this.yShift = yShiftEnd;
        }


        if (progress > 0) {
            this.animations.forEach((item) => {
                const res = getInterpolated(item.cp, progress);

                if (item.tp === 'position') {
                    item.obj.position.set(...res);
                }
                if (item.tp === 'rotation') {
                    item.obj.rotation.set(...res);
                }
                if (item.tp === 'tex_offset') {
                    item.obj.offset = new THREE.Vector2(...res);
                }
                if (item.tp === 'tex_rotation') {
                    item.obj.rotation = res[0];
                }
                if (item.tp === 'mat_opacity') {
                    item.obj.opacity = res[0];
                }
                if (item.tp === '$opacity') {
                    item.obj[0].style.opacity = res[0];

                    if (res[0] >= 0.1) {
                        if (!this.extraCardActive) {
                            item.obj.addClass(Constants.cssClasses.isActive);
                            this.extraCardActive = true;
                        }
                    } else {
                        if (this.extraCardActive) {
                            item.obj.removeClass(Constants.cssClasses.isActive);
                            this.extraCardActive = false;
                        }
                    }
                }
                if (item.tp === '$left') {
                    item.obj[0].style.left = (res[0] + 'px');
                }
                if (item.tp === 'css-translate') {
                    $(item.obj).css('transform', 'translate3d(' + res[0] + 'px, ' + res[1] + 'px, ' + res[2] + 'px)');
                }
            });
        }

        this.camera.setViewOffset(
            this.width,
            this.height,
            this.viewOffset[0] + xShift,
            this.viewOffset[1] + this.yShift,
            this.width,
            this.height
        );

        this.renderer.render(this.scene, this.camera);
    },

    toggleCarousel: function (isActive) {
        if (isActive === this.isCarouselActive) {
            return;
        }

        if (isActive) {
            this.$(Selectors.slider)
                .addClass('owl-carousel owl-theme')
                .owlCarousel({
                    stagePadding: 0,
                    items: 1,
                    margin: 0,
                    singleItem: true,
                    loop: false,
                    dots: true
                });

            this.$(Selectors.slider).on('changed.owl.carousel', function (e) {
                if (e.item.index === null) {
                    return;
                }
                this.$(Selectors.slide + '.' + Constants.cssClasses.isActive).removeClass(Constants.cssClasses.isActive);
                this.$(Selectors.slide + '[data-id="' + e.item.index + '"]').addClass(Constants.cssClasses.isActive);
            }.bind(this));
        } else {
            this.$(Selectors.slider)
                .owlCarousel('destroy')
                .removeClass('owl-carousel owl-theme');

            this.$(Selectors.slide + '.' + Constants.cssClasses.isActive).removeClass(Constants.cssClasses.isActive);
            this.$(Selectors.slide + '[data-id="0"]').addClass(Constants.cssClasses.isActive);
        }

        this.isCarouselActive = isActive;
    },

    toggleSizeWrapper: function (isActive) {
        let maxHeight = 0;

        if (isActive) {
            this.$('.IndexPartners-slide').each((id, item) => {
                const h = $(item).innerHeight();
                maxHeight = (h > maxHeight) ? h : maxHeight;
            });

            this.$('.IndexPartners-partnersBlocks').css('min-height', maxHeight);
        } else {
            this.$('.IndexPartners-partnersBlocks').css('min-height', maxHeight);
        }
    }
});
